exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ActivityModuleRule {\n  padding: 0.16rem 0.12rem;\n  width: 100vw;\n  min-height: 100vh;\n}\n.ActivityModuleRule > div {\n  padding: 0.16rem;\n  background-color: #fff;\n  border-radius: 0.16rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/ActivityModule/rule/index.less
// module id = 1573
// module chunks = 0